export const selectedConids = (state) => {
    return state.selectedConids || [];
}
export const folioModels = (state) => {
    return state.folioModels;
}
export const selectedModel = (state) => {
    return state.selectedModel;
}
export const modelOrdersStatus = (state) => {
    return state.modelOrdersStatus;
}
export const performanceChartData = (state) => {
    return state.performanceChartData;
}
export const savedModelStatus = (state) => {
    return state.savedModelStatus;
}
export const rebalancedOrderDetails = (state) => {
    return state.rebalancedOrderDetails;
}
export const transmitOrdersStatus = (state) => {
    return state.transmitOrdersStatus;
}
export const modelTargetList = (state) => {
    return state.modelTargetList;
}